export const searchVariants = {
	initial: { opacity: 0, scaleX: 0.3 },
	animate: { opacity: 1, scaleX: 1 },
	exit: { opacity: 0, scaleX: 0.3 },
};

export const nothingFoundVariants = {
	initial: { opacity: 0, y: 6 },
	animate: { opacity: 1, y: 0 },
	exit: { opacity: 0, y: 6 },
};

export const searchResultsVariants = {
	initial: { opacity: 0, y: -4 },
	animate: { opacity: 1, y: 0 },
	exit: { opacity: 0, y: -4 },
};

export const positioningVariants = {
	initial: { opacity: 0, y: 10 },
	animate: { opacity: 1, y: 0 },
	exit: { opacity: 0, y: -10 },
};
